<template>
  <div class="drawer">
    <div class="drawer-container">
      <el-tabs v-model="activeName" @tab-click="handleClickTab">
        <el-tab-pane :label="$t('text.baseInfo')" name="detail">
          <div class="drawer-content with-footer">
            <el-form
              class="box"
              ref="customerForm"
              :model="customer"
              label-width="70px"
            >
              <fieldset class="mgb15">
                <el-row>
                  <el-col :span="8">
                    <el-form-item :label="$t('user.name')">{{
                      customer.name
                    }}</el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item :label="$t('user.phone')">{{
                      customer.phone
                    }}</el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item :label="$t('customer.email')">{{
                      customer.email
                    }}</el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="8">
                    <el-form-item :label="$t('text.owner')">{{
                      customer.ownerName
                    }}</el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item :label="$t('text.createAt')">{{
                      customer.createAt
                    }}</el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item :label="$t('customer.source')">
                      {{ customer.source }}
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item
                      :label="$t('customer.suggestName')"
                      v-if="customer.suggestId != null"
                    >
                      {{ customer.suggestName }}
                      <small>({{ customer.suggestPhone }})</small>
                    </el-form-item>
                  </el-col>
                  <el-col :span="16">
                    <el-form-item
                      :label="$t('customer.sourceRemark')"
                      v-if="customer.sourceRemark != null"
                    >
                      {{ customer.sourceRemark }}
                    </el-form-item>
                  </el-col>
                </el-row>
              </fieldset>
              <fieldset class="mgb15">
                <legend>{{ $t("customer.addressInfo") }}</legend>
                <el-row>
                  <el-col :span="8">
                    <el-form-item :label="$t('tenant.province')">{{
                      customer.province
                    }}</el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item :label="$t('tenant.city')">{{
                      customer.city
                    }}</el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item :label="$t('tenant.address')">{{
                      customer.address
                    }}</el-form-item>
                  </el-col>
                </el-row>
              </fieldset>
              <fieldset v-if="customer.remark != null" class="mgb15">
                <legend>{{ $t("text.remark") }}</legend>
                <raw-html :content="customer.remark"></raw-html>
              </fieldset>
            </el-form>
          </div>
        </el-tab-pane>
        <el-tab-pane :label="$t('customer.follows')" name="follow">
          <div class="drawer-content with-tab-footer">
            <div class="box">
              <el-timeline>
                <el-timeline-item
                  v-for="(follow, index) in follows"
                  :key="index"
                  :timestamp="follow.createAt"
                >
                  <span style="color: #909399">{{ follow.ownerName }}</span>
                  <div>
                    <span v-if="follow.type" class="float-left">
                      {{ follow.type }}：
                    </span>
                    <raw-html :content="follow.content"></raw-html>
                  </div>
                </el-timeline-item>
              </el-timeline>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
    <div class="drawer-footer">
      <el-button
        v-if="
          activeName == 'detail' &&
          Permit.canActions('customerDistributiveOwner')
        "
        type="warning"
        plain
        size="small"
        @click="distributiveOwner"
        >{{ $t("action.distributiveOwner") }}</el-button
      >
      <el-button
        v-if="activeName == 'follow'"
        type="success"
        plain
        size="small"
        @click="addServiceFollow"
        >+ {{ $t("customer.follows") }}</el-button
      >
    </div>
    <!-- 分配拥有人 -->
    <el-dialog
      :append-to-body="true"
      :title="$t('action.distributiveOwner')"
      :close-on-click-modal="false"
      :visible.sync="distributiveOwnerDF"
      width="30%"
    >
      <el-form ref="distributiveOwnerObjForm" :model="distributiveOwnerObj">
        <el-form-item
          :prop="'ownerId'"
          :rules="[
            {
              required: true,
              message: $t('rules.required', [$t('text.owner')]),
              trigger: 'blur',
            },
          ]"
        >
          <el-select
            size="small"
            v-model="distributiveOwnerObj.ownerId"
            filterable
            clearable
          >
            <el-option
              v-for="user in users"
              :key="user.id"
              :label="user.name"
              :value="user.id"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          :loading="distributiveOwnerDoing"
          size="small"
          @click="distributiveOwnerSubmit"
          >{{ $t("text.submit") }}</el-button
        >
        <el-button size="small" @click="distributiveOwnerDF = false">{{
          $t("text.close")
        }}</el-button>
      </div>
    </el-dialog>
    <!-- 跟踪 -->
    <el-dialog
      :append-to-body="true"
      :title="$t('customer.follow')"
      :close-on-click-modal="false"
      :visible.sync="addFollowDF"
      width="30%"
    >
      <el-form ref="addFollowForm" label-width="70px" :model="addFollowObj">
        <el-form-item
          :label="$t('text.content')"
          :prop="'content'"
          :rules="[
            {
              required: true,
              message: $t('rules.required', [$t('text.content')]),
              trigger: 'blur',
            },
          ]"
        >
          <el-input
            size="small"
            v-model.trim="addFollowObj.content"
            :placeholder="$t('text.content')"
            type="textarea"
          />
        </el-form-item>
        <el-form-item :prop="'content'">
          <el-checkbox
            v-model="addFollowObj._scheduleDF"
            @change="setScheduleDF"
            >有预约</el-checkbox
          >
        </el-form-item>
        <template v-if="addFollowObj._scheduleDF == true">
          <el-form-item
            :label="$t('schedule.title')"
            :prop="'_title'"
            :rules="[
              {
                required: true,
                message: $t('rules.required', [$t('schedule.title')]),
                trigger: 'blur',
              },
            ]"
          >
            <el-input size="small" v-model.trim="addFollowObj._title" />
          </el-form-item>
          <el-form-item
            :label="$t('schedule.type')"
            :prop="'_type'"
            :rules="[
              {
                required: true,
                message: $t('rules.required', [$t('schedule.type')]),
                trigger: 'blur',
              },
            ]"
          >
            <el-select
              size="small"
              v-model.trim="addFollowObj._type"
              filterable
              clearable
            >
              <el-option
                v-for="scheduleType in scheduleTypes"
                :key="scheduleType.id"
                :label="scheduleType.name"
                :value="scheduleType.name"
              />
            </el-select>
          </el-form-item>
          <el-row>
            <el-col :span="16">
              <el-form-item
                :label="$t('text.date')"
                :prop="'_planAt1'"
                :rules="[
                  {
                    required: true,
                    message: $t('rules.required', [$t('text.date')]),
                    trigger: 'blur',
                  },
                ]"
              >
                <el-date-picker
                  size="small"
                  v-model.trim="addFollowObj._planAt1"
                  type="date"
                  id="right-radius"
                  style="width: 100%"
                />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                label-width="0px"
                :prop="'_planAt2'"
                :rules="[
                  {
                    required: true,
                    message: $t('rules.required', [$t('text.time')]),
                    trigger: 'blur',
                  },
                ]"
              >
                <el-time-select
                  size="small"
                  id="left-radius"
                  style="width: 100%"
                  v-model="addFollowObj._planAt2"
                  :picker-options="{
                    start: '08:30',
                    step: '00:30',
                    end: '20:30',
                  }"
                >
                </el-time-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item
            :label="$t('menu.shops')"
            :prop="'_shopId'"
            :rules="[
              {
                required: true,
                message: $t('rules.required', [$t('menu.shops')]),
                trigger: 'blur',
              },
            ]"
          >
            <el-select
              size="small"
              v-model="addFollowObj._shopId"
              filterable
              clearable
            >
              <el-option
                v-for="shop in shops"
                :key="shop.id"
                :label="shop.name"
                :value="shop.id"
              />
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('customer.source')">
            <el-select
              size="small"
              v-model="addFollowObj._source"
              clearable
              filterable
            >
              <el-option
                v-for="source in sources"
                :key="source.id"
                :label="source.name"
                :value="source.name"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('customer.sourceRemark')">
            <el-autocomplete
              size="small"
              v-model="addFollowObj._sourceRemark"
              :fetch-suggestions="querySearchSourceRemarks"
              style="width: 100%"
              @select="handleSelectSourceRemarks"
            ></el-autocomplete>
          </el-form-item>
          <el-form-item :label="$t('text.remark')" :prop="'_content'">
            <el-input
              size="small"
              v-model.trim="addFollowObj._content"
              type="textarea"
            />
          </el-form-item>
        </template>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          plain
          :loading="addFollowDoing"
          size="small"
          @click="addServiceFollowSubmit"
          >{{ $t("text.submit") }}</el-button
        >
        <el-button size="small" @click="addFollowDF = false">{{
          $t("text.close")
        }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import axios from "axios";
import { page } from "@/utils/mixins.js";
import Util from "@/utils/index.js";
import RawHtml from "@/components/RawHtml";
import Dropzone from "@/components/Dropzone";
import Customer from "@/api/customer.js";
import User from "@/api/user.js";
import Shop from "@/api/shop.js";
import ScheduleType from "@/api/scheduleType.js";
import Schedule from "@/api/schedule.js";
import Source from "@/api/source.js";

export default {
  props: {
    id: Number,
  },
  mixins: [page],
  components: {
    RawHtml,
    Dropzone,
  },
  data() {
    return {
      activeName: "detail",
      customer: { serialNo: null },
      follows: [],
      // 分配拥有人
      distributiveOwnerDF: false,
      distributiveOwnerObj: {
        ownerId: null,
      },
      users: [],
      distributiveOwnerDoing: false,
      // 跟踪
      addFollowDF: false,
      addFollowObj: {
        content: null,
        _scheduleDF: false,
        _title: null,
        _type: null,
        _planAt: null,
        _planAt1: null,
        _planAt2: null,
        _shopId: null,
        _content: null,
        _source: null,
        _sourceRemark: null,
      },
      scheduleTypes: [],
      shops: [],
      sources: [],
      addFollowDoing: false,
    };
  },
  created() {
    const self = this;
    self.handleClickTab();
  },
  methods: {
    handleClickTab() {
      if (this.activeName == "detail") {
        this.getCustomer();
      }
      if (this.activeName == "follow") {
        this.getFollows();
      }
    },
    getCustomer() {
      const self = this;
      self.loadingStart();
      Customer.findById(self.id).then(function (res) {
        if (res.data.code === 200) {
          self.customer = res.data.entity;
        } else {
          self.sysError();
        }
        self.loadingEnd();
      });
    },
    getFollows() {
      const self = this;
      self.loadingStart();
      Customer.follows(self.id).then(function (res) {
        if (res.status === 200) {
          self.follows = res.data;
        } else {
          self.sysError();
        }
        self.loadingEnd();
      });
    },
    // 分配拥有人
    distributiveOwner() {
      const self = this;
      self.distributiveOwnerDoing = false;
      User.findByTenantId(self.Permit.currentTenant().id).then(function (res) {
        if (res.status === 200) {
          self.users = res.data.filter(
            (u) => u.authorizeW === true && u.voidAt == null
          );
          if (self.users.find((u) => u.id === self.customer.ownerId) != null) {
            self.distributiveOwnerObj.ownerId = self.customer.ownerId;
          }
          self.distributiveOwnerDF = true;
        } else {
          self.sysError();
        }
        self.loadingEnd();
      });
    },
    distributiveOwnerSubmit() {
      const self = this;
      this.$refs.distributiveOwnerObjForm.validate((valid) => {
        if (valid) {
          self.distributiveOwnerDoing = true;
          Customer.distributeOwner(
            self.customer.id,
            self.distributiveOwnerObj
          ).then(function (res) {
            self.distributiveOwnerDoing = false;
            self.distributiveOwnerDF = false;
            if (res.status === 200) {
              self.$message({
                message: self.$t("prompt.distributiveSuccess"),
                type: "success",
              });
              self.customer.ownerName = self.users.find(
                (u) => u.id === self.distributiveOwnerObj.ownerId
              ).name;
            } else {
              self.sysError();
            }
          });
        } else {
          return false;
        }
      });
    },
    // 跟踪
    addServiceFollow() {
      const self = this;
      self.addFollowObj.content = null;
      self.addFollowObj._scheduleDF = false;
      self.addFollowDoing = false;
      self.addFollowDF = true;
    },
    setScheduleDF() {
      const self = this;
      if (!self.addFollowObj._scheduleDF) {
        return;
      }
      self.addFollowObj._title = null;
      self.addFollowObj._type = null;
      self.addFollowObj._shopId = null;
      self.addFollowObj._planAt = null;
      self.addFollowObj._planAt1 = null;
      self.addFollowObj._planAt2 = null;
      self.addFollowObj._content = null;
      self.addFollowObj._source = self.customer.source;
      self.addFollowObj._sourceRemark = self.customer.sourceRemark;
      axios
        .all([
          ScheduleType.findByTenantId(),
          Shop.findByTenantId(),
          Source.findByTenantId(),
        ])
        .then(
          axios.spread(function (scheduleTypes, shops, sources) {
            if (scheduleTypes.status === 200) {
              self.scheduleTypes = scheduleTypes.data;
            } else {
              self.sysError();
            }
            if (shops.status === 200) {
              self.shops = shops.data;
              if (
                self.shops.find(
                  (s) => s.id === self.Permit.currentUser()._shopId
                ) != null
              ) {
                self.addFollowObj.shopId = self.Permit.currentUser()._shopId;
              } else {
                self.addFollowObj.shopId = null;
              }
            } else {
              self.sysError();
            }
            if (sources.status == 200) {
              self.sources = sources.data;
            } else {
              self.sysError();
            }
          })
        );
    },
    // 具体来源
    querySearchSourceRemarks(queryString, cb) {
      Customer.sourceRemarks().then(function (res) {
        const sourceRemarks = res.data.map((item) => {
          return { value: item };
        });
        cb(sourceRemarks);
      });
    },
    handleSelectSourceRemarks(item) {},
    addServiceFollowSubmit() {
      const self = this;
      this.$refs.addFollowForm.validate((valid) => {
        if (valid) {
          self.addFollowDoing = true;
          Customer.createFollow(self.customer.id, self.addFollowObj).then(
            function (res) {
              self.addFollowDoing = false;
              self.addFollowDF = false;
              if (res.status === 200) {
                self.$message({
                  message: self.$t("prompt.actionSuccess"),
                  type: "success",
                });
                self.getFollows();
                if (self.addFollowObj._scheduleDF == true) {
                  const data = {
                    title: self.addFollowObj._title,
                    type: self.addFollowObj._type,
                    planAt:
                      Util.formatDate(self.addFollowObj._planAt1) +
                      " " +
                      self.addFollowObj._planAt2 +
                      ":00",
                    customerId: self.customer.id,
                    customerName: self.customer.name,
                    content: self.addFollowObj._content,
                    shopId: self.addFollowObj._shopId,
                  };
                  self.createSchedule(data);
                }
              } else {
                self.sysError();
              }
            }
          );
        } else {
          return false;
        }
      });
    },
    createSchedule(data) {
      const self = this;
      Schedule.create(data).then(function (res) {
        self.addDF = false;
        if (res.data.code === 200) {
        } else {
          self.sysError();
        }
      });
    },
  },
};
</script>